export default __webpack_public_path__ + "static/media/motherIcon.89e5d8af.png";